import { ROLE } from './roles.js';
/**
 * 按品牌隔离（2026-09-25 确认）。
 *
 * 每个用户有「可见品牌」：全部品牌，或一个 / 几个品牌代码。看不到的品牌，
 * 委托书一律当作不存在；辅料库里品牌专用的也看不到（共用的、品牌为空的都看得到）。
 *
 * 前后端调的是同一套函数 —— 与 canEditScope 一样，两边各判各的就会出现
 * 「列表里有、点进去 404」这种最难查的问题。
 */
/** 全部品牌 */
export const ALL_BRANDS = '*';
/** 品牌代码统一大写、去空白、去重 —— 款号前两位就是品牌代码，大小写混着存过 */
export function normalizeBrandCodes(codes) {
    return [...new Set(codes.map((c) => c.trim().toUpperCase()).filter(Boolean))].sort();
}
/** 用户的明确授权。旧 allBrands 仅兼容读取，业务角色必须逐品牌授权。 */
export function brandScopeOf(role, _allBrands, brandCodes) {
    if (role === ROLE.ADMIN)
        return ALL_BRANDS;
    return normalizeBrandCodes(brandCodes);
}
/** 业务有效范围 = 已启用品牌 ∩ 用户授权；管理员业务页也只看启用品牌。 */
export function effectiveBrandScope(scope, enabledCodes) {
    const enabled = normalizeBrandCodes(enabledCodes);
    return scope === ALL_BRANDS ? enabled : enabled.filter((code) => normalizeBrandCodes(scope).includes(code));
}
/** 委托书/款式必须有明确品牌；空品牌的共用辅料例外不能用于业务单据。 */
export function canAccessKnownBrand(scope, brandCd) {
    return Boolean(brandCd?.trim()) && canAccessBrand(scope, brandCd);
}
/**
 * 这个品牌看不看得到。
 * brandCd 为空的数据（辅料库里的共用辅料）谁都看得到。
 */
export function canAccessBrand(scope, brandCd) {
    if (!brandCd)
        return true;
    if (scope === ALL_BRANDS)
        return true;
    return scope.includes(brandCd.trim().toUpperCase());
}
/** 查询用的品牌条件：null = 不限；否则只查这些品牌 */
export function brandFilterOf(scope) {
    return scope === ALL_BRANDS ? null : scope;
}
//# sourceMappingURL=brand-scope.js.map